import React, { useState, useEffect, useRef } from "react";
import { Box, Grid } from "@mui/material";
import panelFields from "./rows";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { dateTimeFormatter } from "src/utils/date/dateHelper";
//IDOGAN;436653;21022025
const DetailPanel = ({ data }: { data: any }) => {
  const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.clientWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const minWidth = Math.max(containerWidth, panelFields.length * 140);

  const handleInputChange = (fieldName: string, value: string) => {
    setInputValues((prev) => ({ ...prev, [fieldName]: value }));
  };

  return (
    <Box ref={containerRef} sx={{ width: "100%", overflowX: "auto" }}>
      <Box
        sx={{
          // minWidth: `${minWidth}px`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid
          container
          sx={{
            padding: "0px",
            flexWrap: "nowrap",
            backgroundColor: "#F4F7FE",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          {panelFields.map((field, index) => (
            <Grid
              key={index}
              item
              sx={{
                flex: 1,
                minWidth: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "10px 8px",
                borderRight: "1px solid #E0E0E0",
                '&:last-child': {
                  borderRight: 'none',
                },
              }}
            >
              <ByzMuiTypography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 700,
                  fontSize: '12px',
                  lineHeight: '1.2',
                  color: '#000000',
                  whiteSpace: 'nowrap',
                }}
              >
                {field.label ?? field.name}
              </ByzMuiTypography>
            </Grid>
          ))}
        </Grid>

        <Grid
          container
          sx={{
            borderBottom: "1px solid #ddd",
            padding: "10px",
            flexWrap: "nowrap",
          }}
        >
          {panelFields.map((field, index) => (
            <Grid
              key={index}
              item
              sx={{
                flex: 1, // ✅ eşit genişlik ver
                minWidth: "120px", // mobilde daralmayı engellemek için
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "8px",
              }}
            >
              {field.type === "text" || field.type === "date" ? (
                field.editable ? (
                  <ByzMuiTextField
                    value={inputValues[field.name] || ""}
                    onChange={(e) =>
                      handleInputChange(field.name, e.target.value)
                    }
                    variant="outlined"
                    size="small"
                    sx={{
                      width: "90%",
                      textAlign: "center",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <ByzMuiTypography sx={{ fontWeight: "normal" }}>
                    {field.type === "date"
                      ? (data[field.name] ? dateTimeFormatter(data[field.name], "dd.MM.yyyy HH:mm") : "–")
                      : (data[field.name] || "–")}
                  </ByzMuiTypography>
                )
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <ByzMuiCheckBox
                    checked={data[field.name] === "1"}
                    disabled
                    sx={{ marginLeft: "15px" }}
                  />
                </Box>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default DetailPanel;
